/** Auto-generated — node scripts/generate-register-regional.mjs */
const REGISTER_I18N_REGIONAL = {
  pa: {
    regHello: 'ਸਤ ਸ੍ਰੀ ਅਕਾਲ!',
    regSelectLanguage: 'ਆਪਣੀ ਸੁਵਿਧਾਜਨਕ ਭਾਸ਼ਾ ਚੁਣੋ।',
    regContinue: 'ਜਾਰੀ ਰੱਖੋ',
    regInviteCode: 'Invite Code',
    regInviteCodePlaceholder: 'ਆਪਣਾ invite code ਦਾਖਲ ਕਰੋ',
    regErrInviteCode: 'Invite code ਲੋੜੀਂਦਾ ਹੈ।',
    regNoInviteCode: 'Invite code ਨਹੀਂ? WhatsApp ਤੇ ਸੰਪਰਕ ਕਰੋ',
    regStepRoleTitle: 'ਤੁਸੀਂ ਕੌਣ ਹੋ?',
    regStepRoleSub: 'ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਜਾਰੀ ਰੱਖਣ ਲਈ ਇੱਕ ਵਿਕਲਪ ਚੁਣੋ।',
    regRoleClient: 'Client / Contractor',
    regRoleClientDesc: 'ਆਪਣੇ ਪ੍ਰੋਜੈਕਟਾਂ ਲਈ excavator, JCB, crane ਅਤੇ ਹੋਰ ਮਸ਼ੀਨਾਂ ਬੁੱਕ ਕਰੋ।',
    regRoleOwner: 'Machine Owner',
    regRoleOwnerDesc: 'ਫਲੀਟ, ਕਮਾਈ ਅਤੇ ਮਸ਼ੀਨ ਉਪਲਬਧਤਾ ਪ੍ਰਬੰਧਿਤ ਕਰੋ।',
    regRoleOperator: 'Operator',
    regRoleOperatorDesc: 'ਨਿਰਧਾਰਤ ਮਸ਼ੀਨਾਂ ਚਲਾਓ ਅਤੇ ਰੋਜ਼ਾਨਾ ਲੌਗ ਭਰੋ।',
    regRoleComingSoon: 'ਜਲਦੀ ਆ ਰਿਹਾ ਹੈ — admin ਨਾਲ ਸੰਪਰਕ ਕਰੋ',
    regStepClientTypeTitle: 'Select client type',
    regStepClientTypeSub: 'Choose the option closest to your work',
    regTier1Individual: 'Individual / Small',
    regTier1Commercial: 'Commercial Project',
    regTier1Government: 'Government / MSME',
    regSub_individualResidential: 'Individual / Residential',
    regSub_farmer: 'Farmer / Agriculture',
    regSub_wellDigging: 'Well Digging',
    regSub_industrial: 'Industrial / Factory',
    regSub_roadConstruction: 'Road Construction',
    regSub_canalIrrigation: 'Canal / Irrigation',
    regSub_railway: 'Railway Route',
    regSub_reraBuilder: 'RERA Builder',
    regSub_pwdGovernment: 'PWD / Government',
    regSub_msmeCommercial: 'MSME / Commercial',
    regOwnerStepTitle: 'Business entity',
    regOwnerStepSub: 'Select how this owner is registered',
    regOwnerTier1Individual: 'Individual',
    regOwnerTier1Business: 'Business',
    regOwnerTier1Corporate: 'Corporate',
    regOwnerSub_individual: 'Individual / Farmer',
    regOwnerSub_soleProprietor: 'Sole Proprietor',
    regOwnerSub_partnership: 'Partnership Firm',
    regOwnerSub_llp: 'LLP',
    regOwnerSub_privateLimited: 'Private Limited (Pvt Ltd)',
    regOwnerSub_opc: 'One Person Company (OPC)',
    regStepAccountTitle: 'ਖਾਤੇ ਦੇ ਵੇਰਵੇ',
    regStepAccountSub: 'ਵੇਰਵੇ ਭਰੋ — 24 ਘੰਟਿਆਂ ਵਿੱਚ admin ਮਨਜ਼ੂਰੀ।',
    regFullName: 'ਪੂਰਾ ਨਾਮ',
    regMobile: 'ਮੋਬਾਈਲ ਨੰਬਰ (+91)',
    regEmail: 'Email Address',
    regEmailOptional: 'ਵੈਕਲਪਿਕ',
    regGstin: 'GSTIN',
    regPanUpload: 'PAN Card Upload',
    regPanHint: 'Image ਜਾਂ PDF, ਵੱਧ ਤੋਂ ਵੱਧ 5 MB',
    regPanSelected: 'ਫਾਈਲ ਚੁਣੀ',
    regKycSection: 'ਪਛਾਣ ਦਸਤਾਵੇਜ਼',
    regPassword: 'ਪਾਸਵਰਡ',
    regConfirmPassword: 'ਪਾਸਵਰਡ ਦੀ ਪੁਸ਼ਟੀ',
    regErrFullName: 'ਪੂਰਾ ਨਾਮ ਲੋੜੀਂਦਾ ਹੈ (ਘੱਟੋ-ਘੱਟ 3 ਅੱਖਰ, ਨੰਬਰ ਨਹੀਂ)।',
    regErrMobile: 'ਵੈਧ 10-ਅੰਕੀ ਮੋਬਾਈਲ ਲੋੜੀਂਦਾ ਹੈ।',
    regErrEmail: 'ਵੈਧ email ਦਾਖਲ ਕਰੋ ਜਾਂ ਖਾਲੀ ਛੱਡੋ।',
    regErrGstin: 'Company ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਲਈ ਵੈਧ GSTIN ਲੋੜੀਂਦਾ ਹੈ।',
    regErrPan: 'PAN card ਅਪਲੋਡ ਲੋੜੀਂਦਾ ਹੈ (image ਜਾਂ PDF, ਵੱਧ ਤੋਂ ਵੱਧ 5 MB)।',
    regErrPassword: 'ਪਾਸਵਰਡ ਘੱਟੋ-ਘੱਟ 8 ਅੱਖਰ, 1 ਵੱਡਾ ਅੱਖਰ, 1 ਨੰਬਰ ਅਤੇ 1 ਵਿਸ਼ੇਸ਼ ਅੱਖਰ।',
    regErrConfirm: 'ਪਾਸਵਰਡ ਮੇਲ ਨਹੀਂ ਖਾਂਦੇ।',
    regPasswordWeak: 'ਕਮਜ਼ੋਰ',
    regPasswordMedium: 'ਮੱਧਮ',
    regPasswordStrong: 'ਮਜ਼ਬੂਤ',
    regSubmit: 'ਸਾਈਨ ਅੱਪ',
    regSubmitting: 'ਜਮਾ ਹੋ ਰਿਹਾ ਹੈ...',
    regSuccessTitle: 'ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਜਮਾ',
    regSuccessMessage: 'Admin ਮਨਜ਼ੂਰੀ ਬਾਕੀ (24 ਘੰਟੇ)। ਖਾਤਾ ਸਕ੍ਰਿਆ ਹੋਣ ਤੇ ਸੂਚਨਾ।',
    ownerNextStep1: "ਅਰਜ਼ੀ ਸਫਲਤਾਪੂਰਵਕ ਜਮ੍ਹਾਂ ਹੋ ਗਈ",
    ownerNextStep2: "24 ਘੰਟਿਆਂ ਵਿੱਚ ਐਡਮਿਨ ਸਮੀਖਿਆ",
    ownerNextStep3: "ਮਨਜ਼ੂਰੀ ਤੇ WhatsApp ਸੂਚਨਾ",
    ownerNextStep4: "ਲਾਗਇਨ → ਮਸ਼ੀਨ ਰਜਿਸਟਰ → ਬੈਂਕ ਵੇਰਵੇ → KYC ਪੂਰਾ ਕਰੋ",
    regApprovalWaiting: 'Admin ਮਨਜ਼ੂਰੀ ਤੋਂ ਬਾਅਦ login ਇੱਥੇ ਆਵੇਗਾ।',
    regApprovalChecking: 'ਮਨਜ਼ੂਰੀ ਸਥਿਤੀ ਜਾਂਚ…',
    regBack: 'ਪਿੱਛੇ',
    regNext: 'ਅੱਗੇ',
    regRegisterFailed: 'ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਅਸਫਲ। ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।',
    regPanUploadFailed: 'PAN ਦਸਤਾਵੇਜ਼ ਅਪਲੋਡ ਨਹੀਂ ਹੋਇਆ।',
    regKycUploadFailed: 'ਪਛਾਣ ਦਸਤਾਵੇਜ਼ ਅਪਲੋਡ ਨਹੀਂ ਹੋਏ।',
    regAppName: 'Development Express',
    regTagline: 'The Gold Standard of Infrastructure',
  },
  or: {
    regHello: 'ନମସ୍କାର!',
    regSelectLanguage: 'ଆପଣଙ୍କ ସুবিধାଜନକ ଭାଷା ବାଛନ୍ତୁ।',
    regContinue: 'ଆଗକୁ ବଢ଼ନ୍ତୁ',
    regInviteCode: 'Invite Code',
    regInviteCodePlaceholder: 'ଆପଣଙ୍କ invite code ଲେଖନ୍ତୁ',
    regErrInviteCode: 'Invite code ଆବଶ୍ୟକ।',
    regNoInviteCode: 'Invite code ନାହିଁ? WhatsApp ରେ ଯୋଗାଯୋଗ କରନ୍ତୁ',
    regStepRoleTitle: 'ଆପଣ କିଏ?',
    regStepRoleSub: 'ନିବନ୍ଧନ ଜାରି ରଖିବାକୁ ଏକ ବିକଳ୍ପ ବାଛନ୍ତୁ।',
    regRoleClient: 'Client / Contractor',
    regRoleClientDesc: 'ଆପଣଙ୍କ ପ୍ରକଳ୍ପ ପାଇଁ excavator, JCB, crane ବୁକ୍ କରନ୍ତୁ।',
    regRoleOwner: 'Machine Owner',
    regRoleOwnerDesc: 'ଫ୍ଲିଟ୍, ଆୟ ଏବଂ ମେସିନ୍ ଉପଲବ୍ଧତା ପରିଚାଳନା କରନ୍ତୁ।',
    regRoleOperator: 'Operator',
    regRoleOperatorDesc: 'ନିର୍ଦ୍ଧାରିତ ମେସିନ୍ ଚଲାନ୍ତୁ ଏବଂ ଦୈନିକ ଲଗ୍ ପୂରଣ କରନ୍ତୁ।',
    regRoleComingSoon: 'ଶୀଘ୍ର — admin ସହ ଯୋଗାଯୋଗ',
    regStepClientTypeTitle: 'Select client type',
    regStepClientTypeSub: 'Choose the option closest to your work',
    regTier1Individual: 'Individual / Small',
    regTier1Commercial: 'Commercial Project',
    regTier1Government: 'Government / MSME',
    regSub_individualResidential: 'Individual / Residential',
    regSub_farmer: 'Farmer / Agriculture',
    regSub_wellDigging: 'Well Digging',
    regSub_industrial: 'Industrial / Factory',
    regSub_roadConstruction: 'Road Construction',
    regSub_canalIrrigation: 'Canal / Irrigation',
    regSub_railway: 'Railway Route',
    regSub_reraBuilder: 'RERA Builder',
    regSub_pwdGovernment: 'PWD / Government',
    regSub_msmeCommercial: 'MSME / Commercial',
    regOwnerStepTitle: 'Business entity',
    regOwnerStepSub: 'Select how this owner is registered',
    regOwnerTier1Individual: 'Individual',
    regOwnerTier1Business: 'Business',
    regOwnerTier1Corporate: 'Corporate',
    regOwnerSub_individual: 'Individual / Farmer',
    regOwnerSub_soleProprietor: 'Sole Proprietor',
    regOwnerSub_partnership: 'Partnership Firm',
    regOwnerSub_llp: 'LLP',
    regOwnerSub_privateLimited: 'Private Limited (Pvt Ltd)',
    regOwnerSub_opc: 'One Person Company (OPC)',
    regStepAccountTitle: 'ଖାତା ବିବରଣୀ',
    regStepAccountSub: 'ବିବରଣୀ ପୂରଣ କରନ୍ତୁ — 24 ଘଣ୍ଟାରେ admin ଅନୁମୋଦନ।',
    regFullName: 'ପୂର୍ଣ୍ଣ ନାମ',
    regMobile: 'ମୋବାଇଲ୍ ନମ୍ବର (+91)',
    regEmail: 'Email Address',
    regEmailOptional: 'ଐଚ୍ଛିକ',
    regGstin: 'GSTIN',
    regPanUpload: 'PAN Card Upload',
    regPanHint: 'Image କିମ୍ବା PDF, ସର୍ବୋଚ୍ଚ 5 MB',
    regPanSelected: 'ଫାଇଲ୍ ବାଛିଲେ',
    regKycSection: 'ପରିଚୟ ଦସ୍ତାବିଜ',
    regPassword: 'ପାସୱାର୍ଡ',
    regConfirmPassword: 'ପାସୱାର୍ଡ ନିଶ୍ଚିତ କରନ୍ତୁ',
    regErrFullName: 'पूरा नाम आवश्यक है (कम से कम 3 अक्षर, संख्या नहीं)।',
    regErrMobile: 'वैध 10-अंकी मोबाइल नंबर आवश्यक है।',
    regErrEmail: 'वैध email दर्ज करें या खाली छोड़ें।',
    regErrGstin: 'Company पंजीकरण के लिए वैध GSTIN आवश्यक है।',
    regErrPan: 'PAN card अपलोड आवश्यक है (image या PDF, अधिकतम 5 MB)।',
    regErrPassword: 'पासवर्ड कम से कम 8 अक्षर का हो, 1 बड़ा अक्षर, 1 संख्या और 1 विशेष अक्षर होना चाहिए।',
    regErrConfirm: 'पासवर्ड मेल नहीं खाते।',
    regPasswordWeak: 'ଦୁର୍ବଳ',
    regPasswordMedium: 'ମଧ୍ୟମ',
    regPasswordStrong: 'ଶକ୍ତିଶାଳୀ',
    regSubmit: 'ସାଇନ୍ ଅପ୍',
    regSubmitting: 'ଜମା ହେଉଛି...',
    regSuccessTitle: 'ନିବନ୍ଧନ ଜମା ହେଲା',
    regSuccessMessage: 'Admin ଅନୁମୋଦନ ବାକି (24 ଘଣ୍ଟା)।',
    ownerNextStep1: "ଆବେଦନ ସଫଳତାର ସହିତ ଦାଖଲ ହେଲା",
    ownerNextStep2: "24 ଘଣ୍ଟା ମଧ୍ୟରେ ଆଡମିନ୍ ସମୀକ୍ଷା",
    ownerNextStep3: "ଅନୁମୋଦନରେ WhatsApp ବିଜ୍ଞପ୍ତି",
    ownerNextStep4: "ଲଗଇନ୍ → ମେସିନ୍ ପଞ୍ଜୀକରଣ → ବ୍ୟାଙ୍କ ବିବରଣୀ → KYC ସମ୍ପୂର୍ଣ୍ଣ କରନ୍ତୁ",
    regApprovalWaiting: 'Admin ଅନୁମୋଦନ ପରେ login ଏଠାରେ ଦେଖାଯିବ।',
    regApprovalChecking: 'ଅନୁମୋଦନ ସ୍ଥିତି ଯାଞ୍ଚ…',
    regBack: 'ପଛକୁ',
    regNext: 'ପରବର୍ତ୍ତୀ',
    regRegisterFailed: 'ନିବନ୍ଧନ ବିଫଳ। ପୁନର୍ବାର ଚେଷ୍ଟା କରନ୍ତୁ।',
    regPanUploadFailed: 'PAN दस्तावेज़ अपलोड नहीं हो सका। कृपया पुनः प्रयास करें।',
    regKycUploadFailed: 'पहचान दस्तावेज़ अपलोड नहीं हो सके। कृपया पुनः प्रयास करें।',
    regAppName: 'Development Express',
    regTagline: 'The Gold Standard of Infrastructure',
  },
  as: {
    regHello: 'নমস্কাৰ!',
    regSelectLanguage: 'আপোনাৰ সুবিধাজনক ভাষা বাছক।',
    regContinue: 'আগবাঢ়ক',
    regInviteCode: 'Invite Code',
    regInviteCodePlaceholder: 'আপোনাৰ invite code লিখক',
    regErrInviteCode: 'Invite code প্ৰয়োজন।',
    regNoInviteCode: 'Invite code নাই? WhatsApp-ত যোগাযোগ কৰক',
    regStepRoleTitle: 'আপনি কে?',
    regStepRoleSub: 'পঞ্জীয়ন অব্যাহত ৰাখিবলৈ এটা বিকল্প বাছক।',
    regRoleClient: 'Client / Contractor',
    regRoleClientDesc: 'আপনার প্রকল্পের জন্য excavator, JCB, crane এবং অন্যান্য মেশিন বুক করুন।',
    regRoleOwner: 'Machine Owner',
    regRoleOwnerDesc: 'আপনার ফ্লিট, আয় এবং মেশিনের প্রাপ্যতা পরিচালনা করুন।',
    regRoleOperator: 'Operator',
    regRoleOperatorDesc: 'নির্ধারিত মেশিন চালান এবং দৈনিক লগ পূরণ করুন।',
    regRoleComingSoon: 'শীঘ্ৰে আহিব — admin-ৰ সৈতে যোগাযোগ',
    regStepClientTypeTitle: 'Select client type',
    regStepClientTypeSub: 'Choose the option closest to your work',
    regTier1Individual: 'Individual / Small',
    regTier1Commercial: 'Commercial Project',
    regTier1Government: 'Government / MSME',
    regSub_individualResidential: 'Individual / Residential',
    regSub_farmer: 'Farmer / Agriculture',
    regSub_wellDigging: 'Well Digging',
    regSub_industrial: 'Industrial / Factory',
    regSub_roadConstruction: 'Road Construction',
    regSub_canalIrrigation: 'Canal / Irrigation',
    regSub_railway: 'Railway Route',
    regSub_reraBuilder: 'RERA Builder',
    regSub_pwdGovernment: 'PWD / Government',
    regSub_msmeCommercial: 'MSME / Commercial',
    regOwnerStepTitle: 'Business entity',
    regOwnerStepSub: 'Select how this owner is registered',
    regOwnerTier1Individual: 'Individual',
    regOwnerTier1Business: 'Business',
    regOwnerTier1Corporate: 'Corporate',
    regOwnerSub_individual: 'Individual / Farmer',
    regOwnerSub_soleProprietor: 'Sole Proprietor',
    regOwnerSub_partnership: 'Partnership Firm',
    regOwnerSub_llp: 'LLP',
    regOwnerSub_privateLimited: 'Private Limited (Pvt Ltd)',
    regOwnerSub_opc: 'One Person Company (OPC)',
    regStepAccountTitle: 'অ্যাকাউন্টের বিবরণ',
    regStepAccountSub: 'বিৱৰণ পূৰণ কৰক — 24 ঘণ্টাত admin অনুমোদন।',
    regFullName: 'সম্পূৰ্ণ নাম',
    regMobile: 'মোবাইল নম্বর (+91)',
    regEmail: 'Email Address',
    regEmailOptional: 'ঐচ্ছিক',
    regGstin: 'GSTIN',
    regPanUpload: 'PAN Card Upload',
    regPanHint: 'Image বা PDF, সর্বোচ্চ 5 MB',
    regPanSelected: 'ফাইল বাছনি কৰা হৈছে',
    regKycSection: 'পৰিচয় পত্ৰ',
    regPassword: 'পাসওয়ার্ড',
    regConfirmPassword: 'পাসওয়ার্ড নিশ্চিত করুন',
    regErrFullName: 'পুরো নাম প্রয়োজন (কমপক্ষে ৩টি অক্ষর, সংখ্যা নয়)।',
    regErrMobile: 'বৈধ ১০-অঙ্কের মোবাইল নম্বর প্রয়োজন।',
    regErrEmail: 'বৈধ email লিখুন অথবা খালি রাখুন।',
    regErrGstin: 'Company নিবন্ধনের জন্য বৈধ GSTIN প্রয়োজন।',
    regErrPan: 'PAN card আপলোড প্রয়োজন (image বা PDF, সর্বোচ্চ 5 MB)।',
    regErrPassword: 'পাসওয়ার্ড কমপক্ষে ৮ অক্ষর, ১টি বড় হাতের অক্ষর, ১টি সংখ্যা ও ১টি বিশেষ অক্ষর থাকতে হবে।',
    regErrConfirm: 'পাসওয়ার্ড মিলছে না।',
    regPasswordWeak: 'দুর্বল',
    regPasswordMedium: 'মাঝারি',
    regPasswordStrong: 'শক্তিশালী',
    regSubmit: 'সাইন আপ করুন',
    regSubmitting: 'জমা দেওয়া হচ্ছে...',
    regSuccessTitle: 'নিবন্ধন জমা হয়েছে',
    regSuccessMessage: 'অ্যাডমিন অনুমোদন বাকি (২৪ ঘণ্টা)। অ্যাকাউন্ট সক্রিয় হলে জানানো হবে।',
    ownerNextStep1: "আবেদন সফলভাৱে জমা হ’ল",
    ownerNextStep2: "২৪ ঘণ্টাত এডমিন পৰ্যালোচনা",
    ownerNextStep3: "অনুমোদনত WhatsApp জাননী",
    ownerNextStep4: "লগইন → মেচিন পঞ্জীয়ন → বেংক বিৱৰণ → KYC সম্পূৰ্ণ কৰক",
    regApprovalWaiting: 'অ্যাডমিন অনুমোদনের পর লগইন এখানে স্বয়ংক্রিয়ভাবে দেখা যাবে।',
    regApprovalChecking: 'অনুমোদনের অবস্থা যাচাই করা হচ্ছে…',
    regBack: 'পিছলৈ',
    regNext: 'পৰৱৰ্তী',
    regRegisterFailed: 'পঞ্জীয়ন বিফল। পুনৰ চেষ্টা কৰক।',
    regPanUploadFailed: 'PAN নথি আপলোড হয়নি। অনুগ্রহ করে আবার চেষ্টা করুন।',
    regKycUploadFailed: 'পরিচয়পত্র আপলোড হয়নি। অনুগ্রহ করে আবার চেষ্টা করুন।',
    regAppName: 'Development Express',
    regTagline: 'The Gold Standard of Infrastructure',
  },
  ne: {
    regHello: 'नमस्ते!',
    regSelectLanguage: 'तपाईंलाई सहज भाषा छान्नुहोस्।',
    regContinue: 'अगाडि बढ्नुहोस्',
    regInviteCode: 'Invite Code',
    regInviteCodePlaceholder: 'आफ्नो invite code प्रविष्ट गर्नुहोस्',
    regErrInviteCode: 'Invite code आवश्यक छ।',
    regNoInviteCode: 'Invite code छैन? WhatsApp मा सम्पर्क गर्नुहोस्',
    regStepRoleTitle: 'तपाईं को हुनुहुन्छ?',
    regStepRoleSub: 'दर्ता जारी राख्न एक विकल्प छान्नुहोस्।',
    regRoleClient: 'Client / Contractor',
    regRoleClientDesc: 'अपनी परियोजनाओं के लिए excavator, JCB, crane और अन्य मशीनें बुक करें।',
    regRoleOwner: 'Machine Owner',
    regRoleOwnerDesc: 'अपना बेड़ा, कमाई और मशीन की उपलब्धता प्रबंधित करें।',
    regRoleOperator: 'Operator',
    regRoleOperatorDesc: 'निर्दिष्ट मशीनें चलाएँ और दैनिक लॉग भरें।',
    regRoleComingSoon: 'छिट्टै — admin सँग सम्पर्क',
    regStepClientTypeTitle: 'Select client type',
    regStepClientTypeSub: 'Choose the option closest to your work',
    regTier1Individual: 'Individual / Small',
    regTier1Commercial: 'Commercial Project',
    regTier1Government: 'Government / MSME',
    regSub_individualResidential: 'Individual / Residential',
    regSub_farmer: 'Farmer / Agriculture',
    regSub_wellDigging: 'Well Digging',
    regSub_industrial: 'Industrial / Factory',
    regSub_roadConstruction: 'Road Construction',
    regSub_canalIrrigation: 'Canal / Irrigation',
    regSub_railway: 'Railway Route',
    regSub_reraBuilder: 'RERA Builder',
    regSub_pwdGovernment: 'PWD / Government',
    regSub_msmeCommercial: 'MSME / Commercial',
    regOwnerStepTitle: 'Business entity',
    regOwnerStepSub: 'Select how this owner is registered',
    regOwnerTier1Individual: 'Individual',
    regOwnerTier1Business: 'Business',
    regOwnerTier1Corporate: 'Corporate',
    regOwnerSub_individual: 'Individual / Farmer',
    regOwnerSub_soleProprietor: 'Sole Proprietor',
    regOwnerSub_partnership: 'Partnership Firm',
    regOwnerSub_llp: 'LLP',
    regOwnerSub_privateLimited: 'Private Limited (Pvt Ltd)',
    regOwnerSub_opc: 'One Person Company (OPC)',
    regStepAccountTitle: 'खाता विवरण',
    regStepAccountSub: 'विवरण भर्नुहोस् — 24 घण्टामा admin स्वीकृति।',
    regFullName: 'पूरा नाम',
    regMobile: 'मोबाइल नम्बर (+91)',
    regEmail: 'Email Address',
    regEmailOptional: 'वैकल्पिक',
    regGstin: 'GSTIN',
    regPanUpload: 'PAN Card Upload',
    regPanHint: 'Image या PDF, अधिकतम 5 MB',
    regPanSelected: 'फ़ाइल चुनी गई',
    regKycSection: 'पहचान दस्तावेज़',
    regPassword: 'पासवर्ड',
    regConfirmPassword: 'पासवर्ड की पुष्टि करें',
    regErrFullName: 'पूरा नाम आवश्यक है (कम से कम 3 अक्षर, संख्या नहीं)।',
    regErrMobile: 'वैध 10-अंकी मोबाइल नंबर आवश्यक है।',
    regErrEmail: 'वैध email दर्ज करें या खाली छोड़ें।',
    regErrGstin: 'Company पंजीकरण के लिए वैध GSTIN आवश्यक है।',
    regErrPan: 'PAN card अपलोड आवश्यक है (image या PDF, अधिकतम 5 MB)।',
    regErrPassword: 'पासवर्ड कम से कम 8 अक्षर का हो, 1 बड़ा अक्षर, 1 संख्या और 1 विशेष अक्षर होना चाहिए।',
    regErrConfirm: 'पासवर्ड मेल नहीं खाते।',
    regPasswordWeak: 'कमज़ोर',
    regPasswordMedium: 'मध्यम',
    regPasswordStrong: 'मज़बूत',
    regSubmit: 'साइन अप',
    regSubmitting: 'पेश हुँदैछ...',
    regSuccessTitle: 'दर्ता पेश भयो',
    regSuccessMessage: 'Admin स्वीकृति बाँकी (24 घण्टा)।',
    ownerNextStep1: "आवेदन सफलतापूर्वक पेश भयो",
    ownerNextStep2: "२४ घण्टाभित्र एडमिन समीक्षा",
    ownerNextStep3: "स्वीकृतिमा WhatsApp सूचना",
    ownerNextStep4: "लगइन → मेसिन दर्ता → बैंक विवरण → KYC पूरा गर्नुहोस्",
    regApprovalWaiting: 'एडमिन की स्वीकृति के बाद लॉगिन यहाँ स्वतः दिखेगा।',
    regApprovalChecking: 'स्वीकृति स्थिति जाँची जा रही है…',
    regBack: 'पछाडि',
    regNext: 'अगाडि',
    regRegisterFailed: 'दर्ता असफल। पुनः प्रयास गर्नुहोस्।',
    regPanUploadFailed: 'PAN दस्तावेज़ अपलोड नहीं हो सका। कृपया पुनः प्रयास करें।',
    regKycUploadFailed: 'पहचान दस्तावेज़ अपलोड नहीं हो सके। कृपया पुनः प्रयास करें।',
    regAppName: 'Development Express',
    regTagline: 'The Gold Standard of Infrastructure',
  },
  kok: {
    regHello: 'नमस्कार!',
    regSelectLanguage: 'तुमकां सोयीची भास निवडात.',
    regContinue: 'फुडें',
    regInviteCode: 'Invite Code',
    regInviteCodePlaceholder: 'अपना invite code दर्ज करें',
    regErrInviteCode: 'Invite code आवश्यक आहे.',
    regNoInviteCode: 'Invite code नाही? WhatsApp वर संपर्क करा',
    regStepRoleTitle: 'तूं कोण आसां?',
    regStepRoleSub: 'नोंदणीसाठी खालीलपैकी एक निवडा.',
    regRoleClient: 'Client / Contractor',
    regRoleClientDesc: 'अपनी परियोजनाओं के लिए excavator, JCB, crane और अन्य मशीनें बुक करें।',
    regRoleOwner: 'Machine Owner',
    regRoleOwnerDesc: 'अपना बेड़ा, कमाई और मशीन की उपलब्धता प्रबंधित करें।',
    regRoleOperator: 'Operator',
    regRoleOperatorDesc: 'निर्दिष्ट मशीनें चलाएँ और दैनिक लॉग भरें।',
    regRoleComingSoon: 'लवकरच — admin शी संपर्क करा',
    regStepClientTypeTitle: 'Select client type',
    regStepClientTypeSub: 'Choose the option closest to your work',
    regTier1Individual: 'Individual / Small',
    regTier1Commercial: 'Commercial Project',
    regTier1Government: 'Government / MSME',
    regSub_individualResidential: 'Individual / Residential',
    regSub_farmer: 'Farmer / Agriculture',
    regSub_wellDigging: 'Well Digging',
    regSub_industrial: 'Industrial / Factory',
    regSub_roadConstruction: 'Road Construction',
    regSub_canalIrrigation: 'Canal / Irrigation',
    regSub_railway: 'Railway Route',
    regSub_reraBuilder: 'RERA Builder',
    regSub_pwdGovernment: 'PWD / Government',
    regSub_msmeCommercial: 'MSME / Commercial',
    regOwnerStepTitle: 'Business entity',
    regOwnerStepSub: 'Select how this owner is registered',
    regOwnerTier1Individual: 'Individual',
    regOwnerTier1Business: 'Business',
    regOwnerTier1Corporate: 'Corporate',
    regOwnerSub_individual: 'Individual / Farmer',
    regOwnerSub_soleProprietor: 'Sole Proprietor',
    regOwnerSub_partnership: 'Partnership Firm',
    regOwnerSub_llp: 'LLP',
    regOwnerSub_privateLimited: 'Private Limited (Pvt Ltd)',
    regOwnerSub_opc: 'One Person Company (OPC)',
    regStepAccountTitle: 'खाते तपशील',
    regStepAccountSub: 'तुमचे तपशील भरा — 24 तासांत admin मंजुरी.',
    regFullName: 'पूर्ण नाव',
    regMobile: 'मोबाइल नंबर (+91)',
    regEmail: 'Email Address',
    regEmailOptional: 'पर्यायी',
    regGstin: 'GSTIN',
    regPanUpload: 'PAN Card Upload',
    regPanHint: 'Image किंवा PDF, कमाल 5 MB',
    regPanSelected: 'फाइल निवडली',
    regKycSection: 'ओळखपत्र',
    regPassword: 'पासवर्ड',
    regConfirmPassword: 'पासवर्ड पुष्टी करा',
    regErrFullName: 'पूरा नाम आवश्यक है (कम से कम 3 अक्षर, संख्या नहीं)।',
    regErrMobile: 'वैध 10-अंकी मोबाइल नंबर आवश्यक है।',
    regErrEmail: 'वैध email दर्ज करें या खाली छोड़ें।',
    regErrGstin: 'Company पंजीकरण के लिए वैध GSTIN आवश्यक है।',
    regErrPan: 'PAN card अपलोड आवश्यक है (image या PDF, अधिकतम 5 MB)।',
    regErrPassword: 'पासवर्ड कम से कम 8 अक्षर का हो, 1 बड़ा अक्षर, 1 संख्या और 1 विशेष अक्षर होना चाहिए।',
    regErrConfirm: 'पासवर्ड मेल नहीं खाते।',
    regPasswordWeak: 'कमज़ोर',
    regPasswordMedium: 'मध्यम',
    regPasswordStrong: 'मज़बूत',
    regSubmit: 'साइन अप',
    regSubmitting: 'सबमिट होत आहे...',
    regSuccessTitle: 'नोंदणी सबमिट झाली',
    regSuccessMessage: 'Admin मंजुरी प्रलंबित (24 तास). खाते सक्रिय झाल्यावर कळवले जाईल.',
    ownerNextStep1: "अर्ज यशस्वीपणान सादर जालो",
    ownerNextStep2: "२४ वरां भितर अॅडमिन पुनरावलोकन",
    ownerNextStep3: "मंजुरीचेर WhatsApp सूचना",
    ownerNextStep4: "लॉगीन → मशीन नोंदणी → बँक तपशील → KYC पूर्ण करात",
    regApprovalWaiting: 'Admin मंजुरीनंतर login येथे स्वयंचलित दिसेल.',
    regApprovalChecking: 'मंजुरी स्थिती तपासत आहे…',
    regBack: 'फाटलें',
    regNext: 'फुडें',
    regRegisterFailed: 'नोंदणी अयशस्वी. कृपया पुन्हा प्रयत्न करा.',
    regPanUploadFailed: 'PAN दस्तऐवज अपलोड होऊ शकला नाही.',
    regKycUploadFailed: 'ओळखपत्र अपलोड होऊ शकले नाही.',
    regAppName: 'Development Express',
    regTagline: 'The Gold Standard of Infrastructure',
  },
  sat: {
    regHello: 'ᱡᱚᱦᱟᱨ!',
    regSelectLanguage: 'ᱟᱢᱟᱜ ᱥੁবিধাজনক ᱯᱟᱹᱨᱥᱤ ᱵᱟᱪᱷᱟᱣ ᱢᱮ।',
    regContinue: 'ᱛᱟᱞᱟ ᱪᱟᱹᱞᱩ',
    regInviteCode: 'Invite Code',
    regInviteCodePlaceholder: 'अपना invite code दर्ज करें',
    regErrInviteCode: 'Invite code आवश्यक है।',
    regNoInviteCode: 'Invite code नहीं है? WhatsApp पर हमसे संपर्क करें',
    regStepRoleTitle: 'ᱟᱢ ᱚᱠᱟ?',
    regStepRoleSub: 'ᱧᱩᱛᱩᱢ ᱞᱟᱹᱜᱤᱫ ᱢᱤᱫ ᱚᱛᱷᱚᱱ ᱵᱟᱪᱷᱟᱣ ᱢᱮ।',
    regRoleClient: 'Client / Contractor',
    regRoleClientDesc: 'अपनी परियोजनाओं के लिए excavator, JCB, crane और अन्य मशीनें बुक करें।',
    regRoleOwner: 'Machine Owner',
    regRoleOwnerDesc: 'अपना बेड़ा, कमाई और मशीन की उपलब्धता प्रबंधित करें।',
    regRoleOperator: 'Operator',
    regRoleOperatorDesc: 'निर्दिष्ट मशीनें चलाएँ और दैनिक लॉग भरें।',
    regRoleComingSoon: 'जल्द आ रहा है — एडमिन से संपर्क करें',
    regStepClientTypeTitle: 'Select client type',
    regStepClientTypeSub: 'Choose the option closest to your work',
    regTier1Individual: 'Individual / Small',
    regTier1Commercial: 'Commercial Project',
    regTier1Government: 'Government / MSME',
    regSub_individualResidential: 'Individual / Residential',
    regSub_farmer: 'Farmer / Agriculture',
    regSub_wellDigging: 'Well Digging',
    regSub_industrial: 'Industrial / Factory',
    regSub_roadConstruction: 'Road Construction',
    regSub_canalIrrigation: 'Canal / Irrigation',
    regSub_railway: 'Railway Route',
    regSub_reraBuilder: 'RERA Builder',
    regSub_pwdGovernment: 'PWD / Government',
    regSub_msmeCommercial: 'MSME / Commercial',
    regOwnerStepTitle: 'Business entity',
    regOwnerStepSub: 'Select how this owner is registered',
    regOwnerTier1Individual: 'Individual',
    regOwnerTier1Business: 'Business',
    regOwnerTier1Corporate: 'Corporate',
    regOwnerSub_individual: 'Individual / Farmer',
    regOwnerSub_soleProprietor: 'Sole Proprietor',
    regOwnerSub_partnership: 'Partnership Firm',
    regOwnerSub_llp: 'LLP',
    regOwnerSub_privateLimited: 'Private Limited (Pvt Ltd)',
    regOwnerSub_opc: 'One Person Company (OPC)',
    regStepAccountTitle: 'खाते का विवरण',
    regStepAccountSub: 'अपना विवरण भरें — 24 घंटे में एडमिन की स्वीकृति।',
    regFullName: 'पूरा नाम',
    regMobile: 'मोबाइल नंबर (+91)',
    regEmail: 'Email Address',
    regEmailOptional: 'वैकल्पिक',
    regGstin: 'GSTIN',
    regPanUpload: 'PAN Card Upload',
    regPanHint: 'Image या PDF, अधिकतम 5 MB',
    regPanSelected: 'फ़ाइल चुनी गई',
    regKycSection: 'पहचान दस्तावेज़',
    regPassword: 'पासवर्ड',
    regConfirmPassword: 'पासवर्ड की पुष्टि करें',
    regErrFullName: 'पूरा नाम आवश्यक है (कम से कम 3 अक्षर, संख्या नहीं)।',
    regErrMobile: 'वैध 10-अंकी मोबाइल नंबर आवश्यक है।',
    regErrEmail: 'वैध email दर्ज करें या खाली छोड़ें।',
    regErrGstin: 'Company पंजीकरण के लिए वैध GSTIN आवश्यक है।',
    regErrPan: 'PAN card अपलोड आवश्यक है (image या PDF, अधिकतम 5 MB)।',
    regErrPassword: 'पासवर्ड कम से कम 8 अक्षर का हो, 1 बड़ा अक्षर, 1 संख्या और 1 विशेष अक्षर होना चाहिए।',
    regErrConfirm: 'पासवर्ड मेल नहीं खाते।',
    regPasswordWeak: 'कमज़ोर',
    regPasswordMedium: 'मध्यम',
    regPasswordStrong: 'मज़बूत',
    regSubmit: 'ᱥᱟᱭᱱ ᱟᱹᱯ',
    regSubmitting: 'जमा हो रहा है...',
    regSuccessTitle: 'ᱧᱩᱛᱩᱢ ᱡᱚᱢᱟ ᱦᱩᱭᱮᱱᱟ',
    regSuccessMessage: 'एडमिन की स्वीकृति लंबित (24 घं.)। खाता सक्रिय होने पर सूचित किया जाएगा।',
    ownerNextStep1: "Abedon safalta sange jama hena",
    ownerNextStep2: "24 ghanta bitre admin review",
    ownerNextStep3: "Manjuri re WhatsApp suchna",
    ownerNextStep4: "Login → Machine register → Bank details → KYC pura",
    regApprovalWaiting: 'एडमिन की स्वीकृति के बाद लॉगिन यहाँ स्वतः दिखेगा।',
    regApprovalChecking: 'स्वीकृति स्थिति जाँची जा रही है…',
    regBack: 'ᱛᱟᱭᱚᱢ',
    regNext: 'ᱛᱟᱞᱟ',
    regRegisterFailed: 'ᱧᱩᱛᱩᱢ ᱵᱤᱯᱚᱨᱴ। ᱫᱚᱦᱲᱟ ᱪᱮᱥᱴᱟ ᱢᱮ।',
    regPanUploadFailed: 'PAN दस्तावेज़ अपलोड नहीं हो सका। कृपया पुनः प्रयास करें।',
    regKycUploadFailed: 'पहचान दस्तावेज़ अपलोड नहीं हो सके। कृपया पुनः प्रयास करें।',
    regAppName: 'Development Express',
    regTagline: 'The Gold Standard of Infrastructure',
  },
  mai: {
    regHello: 'प्रणाम!',
    regSelectLanguage: 'अहाँक सुविधाजनक भाषा चुनू।',
    regContinue: 'आगू बढ़ू',
    regInviteCode: 'Invite Code',
    regInviteCodePlaceholder: 'अपना invite code दर्ज करें',
    regErrInviteCode: 'Invite code आवश्यक है।',
    regNoInviteCode: 'Invite code नहीं है? WhatsApp पर हमसे संपर्क करें',
    regStepRoleTitle: 'अहाँ के छी?',
    regStepRoleSub: 'पंजीकरण जारी रखबाक लेल एक विकल्प चुनू।',
    regRoleClient: 'Client / Contractor',
    regRoleClientDesc: 'अपनी परियोजनाओं के लिए excavator, JCB, crane और अन्य मशीनें बुक करें।',
    regRoleOwner: 'Machine Owner',
    regRoleOwnerDesc: 'अपना बेड़ा, कमाई और मशीन की उपलब्धता प्रबंधित करें।',
    regRoleOperator: 'Operator',
    regRoleOperatorDesc: 'निर्दिष्ट मशीनें चलाएँ और दैनिक लॉग भरें।',
    regRoleComingSoon: 'जल्द आ रहा है — एडमिन से संपर्क करें',
    regStepClientTypeTitle: 'Select client type',
    regStepClientTypeSub: 'Choose the option closest to your work',
    regTier1Individual: 'Individual / Small',
    regTier1Commercial: 'Commercial Project',
    regTier1Government: 'Government / MSME',
    regSub_individualResidential: 'Individual / Residential',
    regSub_farmer: 'Farmer / Agriculture',
    regSub_wellDigging: 'Well Digging',
    regSub_industrial: 'Industrial / Factory',
    regSub_roadConstruction: 'Road Construction',
    regSub_canalIrrigation: 'Canal / Irrigation',
    regSub_railway: 'Railway Route',
    regSub_reraBuilder: 'RERA Builder',
    regSub_pwdGovernment: 'PWD / Government',
    regSub_msmeCommercial: 'MSME / Commercial',
    regOwnerStepTitle: 'Business entity',
    regOwnerStepSub: 'Select how this owner is registered',
    regOwnerTier1Individual: 'Individual',
    regOwnerTier1Business: 'Business',
    regOwnerTier1Corporate: 'Corporate',
    regOwnerSub_individual: 'Individual / Farmer',
    regOwnerSub_soleProprietor: 'Sole Proprietor',
    regOwnerSub_partnership: 'Partnership Firm',
    regOwnerSub_llp: 'LLP',
    regOwnerSub_privateLimited: 'Private Limited (Pvt Ltd)',
    regOwnerSub_opc: 'One Person Company (OPC)',
    regStepAccountTitle: 'खाते का विवरण',
    regStepAccountSub: 'अपना विवरण भरें — 24 घंटे में एडमिन की स्वीकृति।',
    regFullName: 'पूरा नाम',
    regMobile: 'मोबाइल नंबर (+91)',
    regEmail: 'Email Address',
    regEmailOptional: 'वैकल्पिक',
    regGstin: 'GSTIN',
    regPanUpload: 'PAN Card Upload',
    regPanHint: 'Image या PDF, अधिकतम 5 MB',
    regPanSelected: 'फ़ाइल चुनी गई',
    regKycSection: 'पहचान दस्तावेज़',
    regPassword: 'पासवर्ड',
    regConfirmPassword: 'पासवर्ड की पुष्टि करें',
    regErrFullName: 'पूरा नाम आवश्यक है (कम से कम 3 अक्षर, संख्या नहीं)।',
    regErrMobile: 'वैध 10-अंकी मोबाइल नंबर आवश्यक है।',
    regErrEmail: 'वैध email दर्ज करें या खाली छोड़ें।',
    regErrGstin: 'Company पंजीकरण के लिए वैध GSTIN आवश्यक है।',
    regErrPan: 'PAN card अपलोड आवश्यक है (image या PDF, अधिकतम 5 MB)।',
    regErrPassword: 'पासवर्ड कम से कम 8 अक्षर का हो, 1 बड़ा अक्षर, 1 संख्या और 1 विशेष अक्षर होना चाहिए।',
    regErrConfirm: 'पासवर्ड मेल नहीं खाते।',
    regPasswordWeak: 'कमज़ोर',
    regPasswordMedium: 'मध्यम',
    regPasswordStrong: 'मज़बूत',
    regSubmit: 'साइन अप करें',
    regSubmitting: 'जमा हो रहा है...',
    regSuccessTitle: 'पंजीकरण जमा हो गया',
    regSuccessMessage: 'एडमिन की स्वीकृति लंबित (24 घं.)। खाता सक्रिय होने पर सूचित किया जाएगा।',
    ownerNextStep1: "आवेदन सफलतापूर्वक जमा भेल",
    ownerNextStep2: "२४ घंटा मे एडमिन समीक्षा",
    ownerNextStep3: "स्वीकृति पर WhatsApp सूचना",
    ownerNextStep4: "लॉगिन → मशीन रजिस्टर → बैंक विवरण → KYC पूरा करू",
    regApprovalWaiting: 'एडमिन की स्वीकृति के बाद लॉगिन यहाँ स्वतः दिखेगा।',
    regApprovalChecking: 'स्वीकृति स्थिति जाँची जा रही है…',
    regBack: 'पाछाँ',
    regNext: 'आगू',
    regRegisterFailed: 'पंजीकरण विफल। कृपया पुनः प्रयास करें।',
    regPanUploadFailed: 'PAN दस्तावेज़ अपलोड नहीं हो सका। कृपया पुनः प्रयास करें।',
    regKycUploadFailed: 'पहचान दस्तावेज़ अपलोड नहीं हो सके। कृपया पुनः प्रयास करें।',
    regAppName: 'Development Express',
    regTagline: 'The Gold Standard of Infrastructure',
  },
  doi: {
    regHello: 'नमस्कार जी!',
    regSelectLanguage: 'अपनी सुविधाजनक भाषा चुनो।',
    regContinue: 'अग्गें बधो',
    regInviteCode: 'Invite Code',
    regInviteCodePlaceholder: 'अपना invite code दर्ज करें',
    regErrInviteCode: 'Invite code आवश्यक है।',
    regNoInviteCode: 'Invite code नहीं है? WhatsApp पर हमसे संपर्क करें',
    regStepRoleTitle: 'तुस कौन ओ?',
    regStepRoleSub: 'पंजीकरण जारी रखने के लिए एक विकल्प चुनें।',
    regRoleClient: 'Client / Contractor',
    regRoleClientDesc: 'अपनी परियोजनाओं के लिए excavator, JCB, crane और अन्य मशीनें बुक करें।',
    regRoleOwner: 'Machine Owner',
    regRoleOwnerDesc: 'अपना बेड़ा, कमाई और मशीन की उपलब्धता प्रबंधित करें।',
    regRoleOperator: 'Operator',
    regRoleOperatorDesc: 'निर्दिष्ट मशीनें चलाएँ और दैनिक लॉग भरें।',
    regRoleComingSoon: 'जल्द आ रहा है — एडमिन से संपर्क करें',
    regStepClientTypeTitle: 'Select client type',
    regStepClientTypeSub: 'Choose the option closest to your work',
    regTier1Individual: 'Individual / Small',
    regTier1Commercial: 'Commercial Project',
    regTier1Government: 'Government / MSME',
    regSub_individualResidential: 'Individual / Residential',
    regSub_farmer: 'Farmer / Agriculture',
    regSub_wellDigging: 'Well Digging',
    regSub_industrial: 'Industrial / Factory',
    regSub_roadConstruction: 'Road Construction',
    regSub_canalIrrigation: 'Canal / Irrigation',
    regSub_railway: 'Railway Route',
    regSub_reraBuilder: 'RERA Builder',
    regSub_pwdGovernment: 'PWD / Government',
    regSub_msmeCommercial: 'MSME / Commercial',
    regOwnerStepTitle: 'Business entity',
    regOwnerStepSub: 'Select how this owner is registered',
    regOwnerTier1Individual: 'Individual',
    regOwnerTier1Business: 'Business',
    regOwnerTier1Corporate: 'Corporate',
    regOwnerSub_individual: 'Individual / Farmer',
    regOwnerSub_soleProprietor: 'Sole Proprietor',
    regOwnerSub_partnership: 'Partnership Firm',
    regOwnerSub_llp: 'LLP',
    regOwnerSub_privateLimited: 'Private Limited (Pvt Ltd)',
    regOwnerSub_opc: 'One Person Company (OPC)',
    regStepAccountTitle: 'खाते का विवरण',
    regStepAccountSub: 'अपना विवरण भरें — 24 घंटे में एडमिन की स्वीकृति।',
    regFullName: 'पूरा नाम',
    regMobile: 'मोबाइल नंबर (+91)',
    regEmail: 'Email Address',
    regEmailOptional: 'वैकल्पिक',
    regGstin: 'GSTIN',
    regPanUpload: 'PAN Card Upload',
    regPanHint: 'Image या PDF, अधिकतम 5 MB',
    regPanSelected: 'फ़ाइल चुनी गई',
    regKycSection: 'पहचान दस्तावेज़',
    regPassword: 'पासवर्ड',
    regConfirmPassword: 'पासवर्ड की पुष्टि करें',
    regErrFullName: 'पूरा नाम आवश्यक है (कम से कम 3 अक्षर, संख्या नहीं)।',
    regErrMobile: 'वैध 10-अंकी मोबाइल नंबर आवश्यक है।',
    regErrEmail: 'वैध email दर्ज करें या खाली छोड़ें।',
    regErrGstin: 'Company पंजीकरण के लिए वैध GSTIN आवश्यक है।',
    regErrPan: 'PAN card अपलोड आवश्यक है (image या PDF, अधिकतम 5 MB)।',
    regErrPassword: 'पासवर्ड कम से कम 8 अक्षर का हो, 1 बड़ा अक्षर, 1 संख्या और 1 विशेष अक्षर होना चाहिए।',
    regErrConfirm: 'पासवर्ड मेल नहीं खाते।',
    regPasswordWeak: 'कमज़ोर',
    regPasswordMedium: 'मध्यम',
    regPasswordStrong: 'मज़बूत',
    regSubmit: 'साइन अप करें',
    regSubmitting: 'जमा हो रहा है...',
    regSuccessTitle: 'पंजीकरण जमा हो गया',
    regSuccessMessage: 'एडमिन की स्वीकृति लंबित (24 घं.)। खाता सक्रिय होने पर सूचित किया जाएगा।',
    ownerNextStep1: "अर्जी कामयाबी कन्नै जमा होई गई",
    ownerNextStep2: "२४ घंटे च एडमिन समीक्षा",
    ownerNextStep3: "मंजूरी पर WhatsApp सूचना",
    ownerNextStep4: "लॉगिन → मशीन रजिस्टर → बैंक विवरण → KYC पूरा करो",
    regApprovalWaiting: 'एडमिन की स्वीकृति के बाद लॉगिन यहाँ स्वतः दिखेगा।',
    regApprovalChecking: 'स्वीकृति स्थिति जाँची जा रही है…',
    regBack: 'पिछ्छै',
    regNext: 'अग्गें',
    regRegisterFailed: 'पंजीकरण विफल। कृपया पुनः प्रयास करें।',
    regPanUploadFailed: 'PAN दस्तावेज़ अपलोड नहीं हो सका। कृपया पुनः प्रयास करें।',
    regKycUploadFailed: 'पहचान दस्तावेज़ अपलोड नहीं हो सके। कृपया पुनः प्रयास करें।',
    regAppName: 'Development Express',
    regTagline: 'The Gold Standard of Infrastructure',
  },
  bho: {
    regHello: 'प्रणाम!',
    regSelectLanguage: 'रउआँ के सुविधाजनक भाषा चुनल जाव।',
    regContinue: 'आगे बढ़ीं',
    regInviteCode: 'Invite Code',
    regInviteCodePlaceholder: 'अपना invite code दर्ज करें',
    regErrInviteCode: 'Invite code आवश्यक है।',
    regNoInviteCode: 'Invite code नहीं है? WhatsApp पर हमसे संपर्क करें',
    regStepRoleTitle: 'रउआँ कौन बानी?',
    regStepRoleSub: 'पंजीकरण जारी रखे खातिर एक विकल्प चुनल जाव।',
    regRoleClient: 'Client / Contractor',
    regRoleClientDesc: 'अपनी परियोजनाओं के लिए excavator, JCB, crane और अन्य मशीनें बुक करें।',
    regRoleOwner: 'Machine Owner',
    regRoleOwnerDesc: 'अपना बेड़ा, कमाई और मशीन की उपलब्धता प्रबंधित करें।',
    regRoleOperator: 'Operator',
    regRoleOperatorDesc: 'निर्दिष्ट मशीनें चलाएँ और दैनिक लॉग भरें।',
    regRoleComingSoon: 'जल्द आ रहा है — एडमिन से संपर्क करें',
    regStepClientTypeTitle: 'Select client type',
    regStepClientTypeSub: 'Choose the option closest to your work',
    regTier1Individual: 'Individual / Small',
    regTier1Commercial: 'Commercial Project',
    regTier1Government: 'Government / MSME',
    regSub_individualResidential: 'Individual / Residential',
    regSub_farmer: 'Farmer / Agriculture',
    regSub_wellDigging: 'Well Digging',
    regSub_industrial: 'Industrial / Factory',
    regSub_roadConstruction: 'Road Construction',
    regSub_canalIrrigation: 'Canal / Irrigation',
    regSub_railway: 'Railway Route',
    regSub_reraBuilder: 'RERA Builder',
    regSub_pwdGovernment: 'PWD / Government',
    regSub_msmeCommercial: 'MSME / Commercial',
    regOwnerStepTitle: 'Business entity',
    regOwnerStepSub: 'Select how this owner is registered',
    regOwnerTier1Individual: 'Individual',
    regOwnerTier1Business: 'Business',
    regOwnerTier1Corporate: 'Corporate',
    regOwnerSub_individual: 'Individual / Farmer',
    regOwnerSub_soleProprietor: 'Sole Proprietor',
    regOwnerSub_partnership: 'Partnership Firm',
    regOwnerSub_llp: 'LLP',
    regOwnerSub_privateLimited: 'Private Limited (Pvt Ltd)',
    regOwnerSub_opc: 'One Person Company (OPC)',
    regStepAccountTitle: 'खाते का विवरण',
    regStepAccountSub: 'अपना विवरण भरें — 24 घंटे में एडमिन की स्वीकृति।',
    regFullName: 'पूरा नाम',
    regMobile: 'मोबाइल नंबर (+91)',
    regEmail: 'Email Address',
    regEmailOptional: 'वैकल्पिक',
    regGstin: 'GSTIN',
    regPanUpload: 'PAN Card Upload',
    regPanHint: 'Image या PDF, अधिकतम 5 MB',
    regPanSelected: 'फ़ाइल चुनी गई',
    regKycSection: 'पहचान दस्तावेज़',
    regPassword: 'पासवर्ड',
    regConfirmPassword: 'पासवर्ड की पुष्टि करें',
    regErrFullName: 'पूरा नाम आवश्यक है (कम से कम 3 अक्षर, संख्या नहीं)।',
    regErrMobile: 'वैध 10-अंकी मोबाइल नंबर आवश्यक है।',
    regErrEmail: 'वैध email दर्ज करें या खाली छोड़ें।',
    regErrGstin: 'Company पंजीकरण के लिए वैध GSTIN आवश्यक है।',
    regErrPan: 'PAN card अपलोड आवश्यक है (image या PDF, अधिकतम 5 MB)।',
    regErrPassword: 'पासवर्ड कम से कम 8 अक्षर का हो, 1 बड़ा अक्षर, 1 संख्या और 1 विशेष अक्षर होना चाहिए।',
    regErrConfirm: 'पासवर्ड मेल नहीं खाते।',
    regPasswordWeak: 'कमज़ोर',
    regPasswordMedium: 'मध्यम',
    regPasswordStrong: 'मज़बूत',
    regSubmit: 'साइन अप करें',
    regSubmitting: 'जमा हो रहा है...',
    regSuccessTitle: 'पंजीकरण जमा हो गया',
    regSuccessMessage: 'एडमिन की स्वीकृति लंबित (24 घं.)। खाता सक्रिय होने पर सूचित किया जाएगा।',
    ownerNextStep1: "अर्जी सफलतापूर्वक जमा हो गईल",
    ownerNextStep2: "२४ घंटा में एडमिन समीक्षा",
    ownerNextStep3: "मंजूरी पर WhatsApp सूचना",
    ownerNextStep4: "लॉगिन → मशीन रजिस्टर → बैंक विवरण → KYC पूरा करीं",
    regApprovalWaiting: 'एडमिन की स्वीकृति के बाद लॉगिन यहाँ स्वतः दिखेगा।',
    regApprovalChecking: 'स्वीकृति स्थिति जाँची जा रही है…',
    regBack: 'पाछे',
    regNext: 'आगे',
    regRegisterFailed: 'पंजीकरण विफल। कृपया पुनः प्रयास करें।',
    regPanUploadFailed: 'PAN दस्तावेज़ अपलोड नहीं हो सका। कृपया पुनः प्रयास करें।',
    regKycUploadFailed: 'पहचान दस्तावेज़ अपलोड नहीं हो सके। कृपया पुनः प्रयास करें।',
    regAppName: 'Development Express',
    regTagline: 'The Gold Standard of Infrastructure',
  },
  raj: {
    regHello: 'राम राम!',
    regSelectLanguage: 'थारी सुविधाजनक भाषा चुनो।',
    regContinue: 'आगे बढ़ो',
    regInviteCode: 'Invite Code',
    regInviteCodePlaceholder: 'अपना invite code दर्ज करें',
    regErrInviteCode: 'Invite code आवश्यक है।',
    regNoInviteCode: 'Invite code नहीं है? WhatsApp पर हमसे संपर्क करें',
    regStepRoleTitle: 'तूं कोण है?',
    regStepRoleSub: 'पंजीकरण जारी रखने के लिए एक विकल्प चुनें।',
    regRoleClient: 'Client / Contractor',
    regRoleClientDesc: 'अपनी परियोजनाओं के लिए excavator, JCB, crane और अन्य मशीनें बुक करें।',
    regRoleOwner: 'Machine Owner',
    regRoleOwnerDesc: 'अपना बेड़ा, कमाई और मशीन की उपलब्धता प्रबंधित करें।',
    regRoleOperator: 'Operator',
    regRoleOperatorDesc: 'निर्दिष्ट मशीनें चलाएँ और दैनिक लॉग भरें।',
    regRoleComingSoon: 'जल्द आ रहा है — एडमिन से संपर्क करें',
    regStepClientTypeTitle: 'Select client type',
    regStepClientTypeSub: 'Choose the option closest to your work',
    regTier1Individual: 'Individual / Small',
    regTier1Commercial: 'Commercial Project',
    regTier1Government: 'Government / MSME',
    regSub_individualResidential: 'Individual / Residential',
    regSub_farmer: 'Farmer / Agriculture',
    regSub_wellDigging: 'Well Digging',
    regSub_industrial: 'Industrial / Factory',
    regSub_roadConstruction: 'Road Construction',
    regSub_canalIrrigation: 'Canal / Irrigation',
    regSub_railway: 'Railway Route',
    regSub_reraBuilder: 'RERA Builder',
    regSub_pwdGovernment: 'PWD / Government',
    regSub_msmeCommercial: 'MSME / Commercial',
    regOwnerStepTitle: 'Business entity',
    regOwnerStepSub: 'Select how this owner is registered',
    regOwnerTier1Individual: 'Individual',
    regOwnerTier1Business: 'Business',
    regOwnerTier1Corporate: 'Corporate',
    regOwnerSub_individual: 'Individual / Farmer',
    regOwnerSub_soleProprietor: 'Sole Proprietor',
    regOwnerSub_partnership: 'Partnership Firm',
    regOwnerSub_llp: 'LLP',
    regOwnerSub_privateLimited: 'Private Limited (Pvt Ltd)',
    regOwnerSub_opc: 'One Person Company (OPC)',
    regStepAccountTitle: 'खाते का विवरण',
    regStepAccountSub: 'अपना विवरण भरें — 24 घंटे में एडमिन की स्वीकृति।',
    regFullName: 'पूरा नाम',
    regMobile: 'मोबाइल नंबर (+91)',
    regEmail: 'Email Address',
    regEmailOptional: 'वैकल्पिक',
    regGstin: 'GSTIN',
    regPanUpload: 'PAN Card Upload',
    regPanHint: 'Image या PDF, अधिकतम 5 MB',
    regPanSelected: 'फ़ाइल चुनी गई',
    regKycSection: 'पहचान दस्तावेज़',
    regPassword: 'पासवर्ड',
    regConfirmPassword: 'पासवर्ड की पुष्टि करें',
    regErrFullName: 'पूरा नाम आवश्यक है (कम से कम 3 अक्षर, संख्या नहीं)।',
    regErrMobile: 'वैध 10-अंकी मोबाइल नंबर आवश्यक है।',
    regErrEmail: 'वैध email दर्ज करें या खाली छोड़ें।',
    regErrGstin: 'Company पंजीकरण के लिए वैध GSTIN आवश्यक है।',
    regErrPan: 'PAN card अपलोड आवश्यक है (image या PDF, अधिकतम 5 MB)।',
    regErrPassword: 'पासवर्ड कम से कम 8 अक्षर का हो, 1 बड़ा अक्षर, 1 संख्या और 1 विशेष अक्षर होना चाहिए।',
    regErrConfirm: 'पासवर्ड मेल नहीं खाते।',
    regPasswordWeak: 'कमज़ोर',
    regPasswordMedium: 'मध्यम',
    regPasswordStrong: 'मज़बूत',
    regSubmit: 'साइन अप करें',
    regSubmitting: 'जमा हो रहा है...',
    regSuccessTitle: 'पंजीकरण जमा हो गया',
    regSuccessMessage: 'एडमिन की स्वीकृति लंबित (24 घं.)। खाता सक्रिय होने पर सूचित किया जाएगा।',
    ownerNextStep1: "अर्जी सफलतापूर्वक जमा हो गई",
    ownerNextStep2: "२४ घंटा में एडमिन समीक्षा",
    ownerNextStep3: "मंजूरी पर WhatsApp सूचना",
    ownerNextStep4: "लॉगिन → मशीन रजिस्टर → बैंक विवरण → KYC पूरा करो",
    regApprovalWaiting: 'एडमिन की स्वीकृति के बाद लॉगिन यहाँ स्वतः दिखेगा।',
    regApprovalChecking: 'स्वीकृति स्थिति जाँची जा रही है…',
    regBack: 'पाछे',
    regNext: 'आगे',
    regRegisterFailed: 'पंजीकरण विफल। कृपया पुनः प्रयास करें।',
    regPanUploadFailed: 'PAN दस्तावेज़ अपलोड नहीं हो सका। कृपया पुनः प्रयास करें।',
    regKycUploadFailed: 'पहचान दस्तावेज़ अपलोड नहीं हो सके। कृपया पुनः प्रयास करें।',
    regAppName: 'Development Express',
    regTagline: 'The Gold Standard of Infrastructure',
  },
  cg: {
    regHello: 'जयहिंद!',
    regSelectLanguage: 'अपन सुविधाजनक भाषा चुनव।',
    regContinue: 'आगे बढ़व',
    regInviteCode: 'Invite Code',
    regInviteCodePlaceholder: 'अपना invite code दर्ज करें',
    regErrInviteCode: 'Invite code आवश्यक है।',
    regNoInviteCode: 'Invite code नहीं है? WhatsApp पर हमसे संपर्क करें',
    regStepRoleTitle: 'तुम का हो?',
    regStepRoleSub: 'पंजीकरण जारी रखने के लिए एक विकल्प चुनें।',
    regRoleClient: 'Client / Contractor',
    regRoleClientDesc: 'अपनी परियोजनाओं के लिए excavator, JCB, crane और अन्य मशीनें बुक करें।',
    regRoleOwner: 'Machine Owner',
    regRoleOwnerDesc: 'अपना बेड़ा, कमाई और मशीन की उपलब्धता प्रबंधित करें।',
    regRoleOperator: 'Operator',
    regRoleOperatorDesc: 'निर्दिष्ट मशीनें चलाएँ और दैनिक लॉग भरें।',
    regRoleComingSoon: 'जल्द आ रहा है — एडमिन से संपर्क करें',
    regStepClientTypeTitle: 'Select client type',
    regStepClientTypeSub: 'Choose the option closest to your work',
    regTier1Individual: 'Individual / Small',
    regTier1Commercial: 'Commercial Project',
    regTier1Government: 'Government / MSME',
    regSub_individualResidential: 'Individual / Residential',
    regSub_farmer: 'Farmer / Agriculture',
    regSub_wellDigging: 'Well Digging',
    regSub_industrial: 'Industrial / Factory',
    regSub_roadConstruction: 'Road Construction',
    regSub_canalIrrigation: 'Canal / Irrigation',
    regSub_railway: 'Railway Route',
    regSub_reraBuilder: 'RERA Builder',
    regSub_pwdGovernment: 'PWD / Government',
    regSub_msmeCommercial: 'MSME / Commercial',
    regOwnerStepTitle: 'Business entity',
    regOwnerStepSub: 'Select how this owner is registered',
    regOwnerTier1Individual: 'Individual',
    regOwnerTier1Business: 'Business',
    regOwnerTier1Corporate: 'Corporate',
    regOwnerSub_individual: 'Individual / Farmer',
    regOwnerSub_soleProprietor: 'Sole Proprietor',
    regOwnerSub_partnership: 'Partnership Firm',
    regOwnerSub_llp: 'LLP',
    regOwnerSub_privateLimited: 'Private Limited (Pvt Ltd)',
    regOwnerSub_opc: 'One Person Company (OPC)',
    regStepAccountTitle: 'खाते का विवरण',
    regStepAccountSub: 'अपना विवरण भरें — 24 घंटे में एडमिन की स्वीकृति।',
    regFullName: 'पूरा नाम',
    regMobile: 'मोबाइल नंबर (+91)',
    regEmail: 'Email Address',
    regEmailOptional: 'वैकल्पिक',
    regGstin: 'GSTIN',
    regPanUpload: 'PAN Card Upload',
    regPanHint: 'Image या PDF, अधिकतम 5 MB',
    regPanSelected: 'फ़ाइल चुनी गई',
    regKycSection: 'पहचान दस्तावेज़',
    regPassword: 'पासवर्ड',
    regConfirmPassword: 'पासवर्ड की पुष्टि करें',
    regErrFullName: 'पूरा नाम आवश्यक है (कम से कम 3 अक्षर, संख्या नहीं)।',
    regErrMobile: 'वैध 10-अंकी मोबाइल नंबर आवश्यक है।',
    regErrEmail: 'वैध email दर्ज करें या खाली छोड़ें।',
    regErrGstin: 'Company पंजीकरण के लिए वैध GSTIN आवश्यक है।',
    regErrPan: 'PAN card अपलोड आवश्यक है (image या PDF, अधिकतम 5 MB)।',
    regErrPassword: 'पासवर्ड कम से कम 8 अक्षर का हो, 1 बड़ा अक्षर, 1 संख्या और 1 विशेष अक्षर होना चाहिए।',
    regErrConfirm: 'पासवर्ड मेल नहीं खाते।',
    regPasswordWeak: 'कमज़ोर',
    regPasswordMedium: 'मध्यम',
    regPasswordStrong: 'मज़बूत',
    regSubmit: 'साइन अप करें',
    regSubmitting: 'जमा हो रहा है...',
    regSuccessTitle: 'पंजीकरण जमा हो गया',
    regSuccessMessage: 'एडमिन की स्वीकृति लंबित (24 घं.)। खाता सक्रिय होने पर सूचित किया जाएगा।',
    ownerNextStep1: "अर्जी सफलतापूर्वक जमा होइस",
    ownerNextStep2: "२४ घंटा मं एडमिन समीक्षा",
    ownerNextStep3: "मंजूरी मं WhatsApp सूचना",
    ownerNextStep4: "लॉगिन → मशीन रजिस्टर → बैंक विवरण → KYC पूरा करव",
    regApprovalWaiting: 'एडमिन की स्वीकृति के बाद लॉगिन यहाँ स्वतः दिखेगा।',
    regApprovalChecking: 'स्वीकृति स्थिति जाँची जा रही है…',
    regBack: 'पीछे',
    regNext: 'आगे',
    regRegisterFailed: 'पंजीकरण विफल। कृपया पुनः प्रयास करें।',
    regPanUploadFailed: 'PAN दस्तावेज़ अपलोड नहीं हो सका। कृपया पुनः प्रयास करें।',
    regKycUploadFailed: 'पहचान दस्तावेज़ अपलोड नहीं हो सके। कृपया पुनः प्रयास करें।',
    regAppName: 'Development Express',
    regTagline: 'The Gold Standard of Infrastructure',
  },
  har: {
    regHello: 'राम राम!',
    regSelectLanguage: 'अपणी सुविधाजनक भाषा चुनो।',
    regContinue: 'आगे बढ़ो',
    regInviteCode: 'Invite Code',
    regInviteCodePlaceholder: 'अपना invite code दर्ज करें',
    regErrInviteCode: 'Invite code आवश्यक है।',
    regNoInviteCode: 'Invite code नहीं है? WhatsApp पर हमसे संपर्क करें',
    regStepRoleTitle: 'तू कोण सै?',
    regStepRoleSub: 'पंजीकरण जारी रखने के लिए एक विकल्प चुनें।',
    regRoleClient: 'Client / Contractor',
    regRoleClientDesc: 'अपनी परियोजनाओं के लिए excavator, JCB, crane और अन्य मशीनें बुक करें।',
    regRoleOwner: 'Machine Owner',
    regRoleOwnerDesc: 'अपना बेड़ा, कमाई और मशीन की उपलब्धता प्रबंधित करें।',
    regRoleOperator: 'Operator',
    regRoleOperatorDesc: 'निर्दिष्ट मशीनें चलाएँ और दैनिक लॉग भरें।',
    regRoleComingSoon: 'जल्द आ रहा है — एडमिन से संपर्क करें',
    regStepClientTypeTitle: 'Select client type',
    regStepClientTypeSub: 'Choose the option closest to your work',
    regTier1Individual: 'Individual / Small',
    regTier1Commercial: 'Commercial Project',
    regTier1Government: 'Government / MSME',
    regSub_individualResidential: 'Individual / Residential',
    regSub_farmer: 'Farmer / Agriculture',
    regSub_wellDigging: 'Well Digging',
    regSub_industrial: 'Industrial / Factory',
    regSub_roadConstruction: 'Road Construction',
    regSub_canalIrrigation: 'Canal / Irrigation',
    regSub_railway: 'Railway Route',
    regSub_reraBuilder: 'RERA Builder',
    regSub_pwdGovernment: 'PWD / Government',
    regSub_msmeCommercial: 'MSME / Commercial',
    regOwnerStepTitle: 'Business entity',
    regOwnerStepSub: 'Select how this owner is registered',
    regOwnerTier1Individual: 'Individual',
    regOwnerTier1Business: 'Business',
    regOwnerTier1Corporate: 'Corporate',
    regOwnerSub_individual: 'Individual / Farmer',
    regOwnerSub_soleProprietor: 'Sole Proprietor',
    regOwnerSub_partnership: 'Partnership Firm',
    regOwnerSub_llp: 'LLP',
    regOwnerSub_privateLimited: 'Private Limited (Pvt Ltd)',
    regOwnerSub_opc: 'One Person Company (OPC)',
    regStepAccountTitle: 'खाते का विवरण',
    regStepAccountSub: 'अपना विवरण भरें — 24 घंटे में एडमिन की स्वीकृति।',
    regFullName: 'पूरा नाम',
    regMobile: 'मोबाइल नंबर (+91)',
    regEmail: 'Email Address',
    regEmailOptional: 'वैकल्पिक',
    regGstin: 'GSTIN',
    regPanUpload: 'PAN Card Upload',
    regPanHint: 'Image या PDF, अधिकतम 5 MB',
    regPanSelected: 'फ़ाइल चुनी गई',
    regKycSection: 'पहचान दस्तावेज़',
    regPassword: 'पासवर्ड',
    regConfirmPassword: 'पासवर्ड की पुष्टि करें',
    regErrFullName: 'पूरा नाम आवश्यक है (कम से कम 3 अक्षर, संख्या नहीं)।',
    regErrMobile: 'वैध 10-अंकी मोबाइल नंबर आवश्यक है।',
    regErrEmail: 'वैध email दर्ज करें या खाली छोड़ें।',
    regErrGstin: 'Company पंजीकरण के लिए वैध GSTIN आवश्यक है।',
    regErrPan: 'PAN card अपलोड आवश्यक है (image या PDF, अधिकतम 5 MB)।',
    regErrPassword: 'पासवर्ड कम से कम 8 अक्षर का हो, 1 बड़ा अक्षर, 1 संख्या और 1 विशेष अक्षर होना चाहिए।',
    regErrConfirm: 'पासवर्ड मेल नहीं खाते।',
    regPasswordWeak: 'कमज़ोर',
    regPasswordMedium: 'मध्यम',
    regPasswordStrong: 'मज़बूत',
    regSubmit: 'साइन अप करें',
    regSubmitting: 'जमा हो रहा है...',
    regSuccessTitle: 'पंजीकरण जमा हो गया',
    regSuccessMessage: 'एडमिन की स्वीकृति लंबित (24 घं.)। खाता सक्रिय होने पर सूचित किया जाएगा।',
    ownerNextStep1: "अर्जी सफलतापूर्वक जमा हो गई",
    ownerNextStep2: "२४ घंटे में एडमिन समीक्षा",
    ownerNextStep3: "मंजूरी पर WhatsApp सूचना",
    ownerNextStep4: "लॉगिन → मशीन रजिस्टर → बैंक विवरण → KYC पूरा करो",
    regApprovalWaiting: 'एडमिन की स्वीकृति के बाद लॉगिन यहाँ स्वतः दिखेगा।',
    regApprovalChecking: 'स्वीकृति स्थिति जाँची जा रही है…',
    regBack: 'पाछे',
    regNext: 'आगे',
    regRegisterFailed: 'पंजीकरण विफल। कृपया पुनः प्रयास करें।',
    regPanUploadFailed: 'PAN दस्तावेज़ अपलोड नहीं हो सका। कृपया पुनः प्रयास करें।',
    regKycUploadFailed: 'पहचान दस्तावेज़ अपलोड नहीं हो सके। कृपया पुनः प्रयास करें।',
    regAppName: 'Development Express',
    regTagline: 'The Gold Standard of Infrastructure',
  },
};

export default REGISTER_I18N_REGIONAL;
